module.exports = __webpack_public_path__ + "static/media/surgical-cervlam-wm.a9d93ffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/surgical-cervlam-wm.jpg
// module id = 253
// module chunks = 1